// extracted by mini-css-extract-plugin
module.exports = {"input":"input--OKOgh","editing":"editing--TrxLJ","enter":"enter--KoaJq","delete":"delete--RCUur"};